import {
  TextField,
  StandardTextFieldProps,
} from "@mui/material";
import React, { useState, ChangeEvent, useEffect } from "react";

interface CpfFieldProps
  extends Omit<StandardTextFieldProps, "value" | "onChange"> {
  value?: string;
  onUpdate?: (cpf: string) => void;
  customStyles?: React.CSSProperties;
  customClassName?: string;
  numericKeyboard?: boolean;
}

const CpfField: React.FC<CpfFieldProps> = ({
  value = "",
  onUpdate,
  customStyles,
  customClassName,
  numericKeyboard = false,
  InputProps,
  ...rest
}) => {
  const [cpf, setCpf] = useState<string>(value);
  useEffect(() => {
    setCpf(value);
  }, [value]);

  const formatCpf = (value: string): string => {
    return value
      .replace(/\D/g, "")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const value = event.target.value;
    const formattedValue = formatCpf(value);
    setCpf(formattedValue);
    onUpdate?.(formattedValue);
  };

  return (
    <div style={{ width: "100%" }}>
      {/* Evita sobreposição */}
      <TextField
        {...rest}
        id="cpf-input"
        value={cpf}
        onChange={handleChange}
        variant="standard"
        fullWidth
        aria-label="CPF"
        data-testid="cpf"
        style={{
          backgroundColor: "#FFF",
          ...customStyles,
        }}
        InputLabelProps={{
          shrink: true, // Evita label sobreposto
          style: {
            color: "#000", // Cor do label
            fontWeight: 400,
          },
        }}
        InputProps={{
          ...InputProps,
          disableUnderline: true,
          className: customClassName || InputProps?.className,
          inputProps: {
            ...InputProps?.inputProps,
            maxLength: 14,
            ...(numericKeyboard
              ? {
                  inputMode: "numeric",
                }
              : {}),
          },
        }}
      />
    </div>
  );
};

export default CpfField;
